import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=0bb0445b&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=ts"
export * from "./GroupsList.vue?vue&type=script&lang=ts"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=0bb0445b&prod&lang=scss&scoped=true"
import style1 from "./GroupsList.vue?vue&type=style&index=1&id=0bb0445b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb0445b",
  null
  
)

export default component.exports